import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { id, SetupLessons } from "./id";

const get = function (params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: SetupLessons[];
  }>("/setup/lessons", { params });
};

const post = function (data: SetupLessons) {
  return api.post("/setup/lessons", data);
};

export const lessons = {
  get,
  post,
  id,
};
